import login from '../pages/Login'
import register from '../pages/register'
import forgetPassword from '../pages/forget-password'
import defaultLayout from '../layouts/defalut-layout'
import authenticateUser from '../pages/authenticate-user.vue'
import externalShare from '../pages/external-share.vue'
import { objectToParams } from '../util/params'
import { PATIENT_APP_URL } from 'config'

export default [
  {
    name: 'login',
    path: '/login',
    component: defaultLayout,
    children: [
      {
        name: 'loginPage',
        path: '',
        components: { body: login }
      }
    ]
  },
  {
    name: 'register',
    path: '/register',
    component: defaultLayout,
    children: [
      {
        name: 'registerPage',
        path: '',
        components: { body: register }
      }
    ]
  },
  {
    name: 'forgetPassword',
    path: '/forget-password',
    component: defaultLayout,
    children: [
      {
        name: 'forgetPasswordPage',
        path: '',
        components: { body: forgetPassword }
      }
    ]
  },
  {
    name: 'authenticateUser',
    path: '/authenticate-user',
    component: authenticateUser
  },
  {
    name: 'SecureUpload',
    path: '/secure-upload',
    beforeEnter: to => {
      location.replace(`${PATIENT_APP_URL}secure-upload/?${objectToParams(to.query)}`)
    }
  },
  {
    name: 'externalShare',
    path: '/external-share/s/:shareId',
    component: defaultLayout,
    children: [
      {
        name: 'externalShare',
        path: '',
        components: { body: externalShare }
      }
    ]
  },
  {
    name: 'authenticateUser',
    path: '/authenticate-user/user/:userId',
    component: authenticateUser
  }
]
